import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  initializeAccountApiService,
  type InitializeAccountResponse,
  type SupportedLanguage,
} from "@/generated/fastapi";

export async function parseResume(
  accessToken: string | null | undefined,
  preferredLanguage: SupportedLanguage,
  selectedFile: File,
): Promise<InitializeAccountResponse> {
  const response = await initializeAccountApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: {
      source_file: selectedFile as unknown as string,
    },
    query: {
      preferred_language: preferredLanguage,
    },
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Resume parsing failed");
  }

  if (response.data.status !== "success") {
    throw new Error(response.data.message || "Resume parsing failed");
  }

  return response.data as InitializeAccountResponse;
}
